export const API_GET_ALL_INSURANCE = 'API_GET_ALL_INSURANCE'
export const API_GET_ALL_INSURANCE_SUCCESS = 'API_GET_ALL_INSURANCE_SUCCESS'
export const API_GET_ALL_INSURANCE_FAIL = 'API_GET_ALL_INSURANCE_FAIL'

export const API_ADMIN_GET_ALL_INSURANCE = 'API_ADMIN_GET_ALL_INSURANCE'
export const API_ADMIN_GET_ALL_INSURANCE_SUCCESS = 'API_ADMIN_GET_ALL_INSURANCE_SUCCESS'
export const API_ADMIN_GET_ALL_INSURANCE_FAIL = 'API_ADMIN_GET_ALL_INSURANCE_FAIL'

export const API_ADMIN_GET_INSURANCE = 'API_ADMIN_GET_INSURANCE'
export const API_ADMIN_GET_INSURANCE_SUCCESS = 'API_ADMIN_GET_INSURANCE_SUCCESS'
export const API_ADMIN_GET_INSURANCE_FAIL = 'API_ADMIN_GET_INSURANCE_FAIL'

export const API_ADMIN_POST_INSURANCE = 'API_ADMIN_POST_INSURANCE';
export const API_ADMIN_POST_INSURANCE_SUCCESS = 'API_ADMIN_POST_INSURANCE_SUCCESS';
export const API_ADMIN_POST_INSURANCE_FAIL = 'API_ADMIN_POST_INSURANCE_FAIL';

export const API_ADMIN_PATCH_INSURANCE = 'API_ADMIN_PATCH_INSURANCE';
export const API_ADMIN_PATCH_INSURANCE_SUCCESS = 'API_ADMIN_PATCH_INSURANCE_SUCCESS';
export const API_ADMIN_PATCH_INSURANCE_FAIL = 'API_ADMIN_PATCH_INSURANCE_FAIL';

export const API_ADMIN_DELETE_INSURANCE = 'API_ADMIN_DELETE_INSURANCE';
export const API_ADMIN_DELETE_INSURANCE_SUCCESS = 'API_ADMIN_DELETE_INSURANCE_SUCCESS';
export const API_ADMIN_DELETE_INSURANCE_FAIL = 'API_ADMIN_DELETE_INSURANCE_FAIL';

export const ADMIN_INIT_NEW_INSURANCE = 'ADMIN_INIT_NEW_INSURANCE'

export const ADMIN_RESET_FOCUS_INSURANCE = 'ADMIN_RESET_FOCUS_INSURANCE'

export const API_SEARCH_INSURANCE = 'API_SEARCH_INSURANCE'
export const API_SEARCH_INSURANCE_SUCCESS = 'API_SEARCH_INSURANCE_SUCCESS'
export const API_SEARCH_INSURANCE_FAIL = 'API_SEARCH_INSURANCE_FAIL'